document.addEventListener('DOMContentLoaded', function () {

  function targetClass(targetListClass,targetitemClass) {
    if (document.querySelectorAll(targetListClass).length === 0) {
      return
    }
    // 全てのアイテムリストを取得
    const itemsLists = document.querySelectorAll(targetListClass)
  
    // 各アイテムリストをループ処理
    itemsLists.forEach(function(list) {
      const items = list.querySelectorAll(targetitemClass)
      // アイテム数が奇数の場合、空のリストアイテムを追加
      if (items.length % 2 !== 0) {
        const emptyItem = document.createElement('li')
        // クラスセレクタの先頭のピリオドを削除してクラス名を取得
        const className = targetitemClass.slice(1)
        emptyItem.className = className
        list.appendChild(emptyItem)
      }
    })
  }
  targetClass('.p-taxonomies__itemsList','.p-taxonomies__item')
  targetClass('.p-purposes__itemsList','.p-purposes__item')
  targetClass('.p-makers__itemsList','.p-makers__item')
})


